import { FormInputRow } from 'components/input';
import React from 'react';
import { useRMDispatch } from 'redux/hooks';
import { useErrorVisibility, useIngredientInfo } from 'redux/hooks/IngredientDetail';
import { setIngredientInfoByKey } from 'redux/reducers/ingredientDetailReducer';

const Info = () => {
  const ingredientInfo = useIngredientInfo();
  const dispatch = useRMDispatch();
  const errorVisible = useErrorVisibility();

  const handleNameChange = (e) => {
    dispatch(setIngredientInfoByKey({ key: e.target.name, value: e.target.value }));
  };

  return (
    <div
      id="ingredientinfo-main-container"
      className="p-2 basis-full flex flex-col dashed-border"
    >
      <div id="ingredientinfo-title" className="basis-1/5 font-bold">
        Ingredient Info
      </div>
      <div
        id="ingredientinfo-forminputrow-wrappers"
        className="pl-4 flex flex-col gap-2 basis-4/5"
      >
        <FormInputRow
          id='ingredientinfo-forminputrow-ingid'
          name="ingId"
          labeltext="ID"
          onChange={() => {}}
          value={ingredientInfo.id.toString().padStart(5, '0')}
          disabled
          inputStyle={{ width: '50%' }}
          labelClassname={'text-[13px]'}
        />
        <FormInputRow
          id='ingredientinfo-forminputrow-longname'
          name="longName"
          labeltext="Long Name"
          onChange={handleNameChange}
          value={ingredientInfo?.longName}
          errorMessage={
            errorVisible && !ingredientInfo?.longName ? 'Long Name must not be empty' : ''
          }
          disabled={ingredientInfo.isUsed}
          labelClassname={'text-[13px]'}
        />
        <FormInputRow
          id='ingredientinfo-forminputrow-shortnamw'
          name="shortName"
          labeltext="Short Name"
          onChange={handleNameChange}
          value={ingredientInfo?.shortName}
          errorMessage={
            errorVisible && !ingredientInfo?.shortName
              ? 'Short Name must not be empty'
              : ''
          }
          disabled={ingredientInfo.isUsed}
          labelClassname={'text-[13px]'}
        />
      </div>
    </div>
  );
};

export default Info;
